const info = {
    $schema: '../../assetlist.schema.json',
    chain_name: 'statemine',
    assets: [{
            denom_units: [{
                    denom: '130',
                    exponent: 0
                }, {
                    denom: 'usdt',
                    exponent: 6
                }],
            type_asset: 'substrate',
            base: '130',
            name: 'Statemine',
            display: 'usdt',
            symbol: 'USDT',
            coingecko_id: 'tether'
        }]
};
export default info;
